// bet-amount-slice.js
import { createSlice } from "@reduxjs/toolkit";

const betAmountSlice = createSlice({
  name: "betAmount",
  initialState: 0,
  reducers: {
    setBetAmount(state, action) {
      const v = action.payload;
      // prihvati samo finitan broj; sve drugo ignoriši
      return (typeof v === "number" && Number.isFinite(v)) ? v : state;
    },
    resetBetAmount() {
      return 0;
    }
  }
});

export const { setBetAmount, resetBetAmount } = betAmountSlice.actions;
export default betAmountSlice.reducer;